export const PREFIX_IN_BROWSER_TAB = 'eloomi';
